import edit from './edit';
import save from './save';
import './style.scss';
import accItmHdrBlockMeta from './block.json';
import { accordionIcon as icon } from './icons';

const { registerBlockType } = wp.blocks;

const { name, ...settings } = accItmHdrBlockMeta;

registerBlockType(name, {
  ...settings,
  icon,
  edit,
  save,
});
